import React from 'react';
import { View, ScrollView,StyleSheet,Animated,TouchableOpacity,Image,Dimensions,Modal , ImageBackground, ActivityIndicator} from 'react-native';
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import { WebView } from 'react-native-webview';
import { Surface } from 'react-native-paper';
import { connect } from 'react-redux';
import {Text, Styles} from "./../../components/UI-Components";
// import AdsScreen from './../Ads';
// import Video from 'react-native-video';
import {  getExams, dispatchClearExams } from './../../store/actions';
import { TextInput,Button} from 'react-native-paper';
import TextField from '@material-ui/core/TextField';
import Header from "./../../components/Header/index.js";
import Container from '@material-ui/core/Container';

const width = 480;
const _width = window.innerWidth;
 

class ContactUS extends React.Component{ 
    
    state = {
        subject: '',
        description: '',
        subjectError:false,
        messageError: false
     }

 
    componentDidUpdate(prevProps) {       
      
    }

    errorHandler = (fieldName, errVal) => {
        this.setState(
          {
            [fieldName]: errVal,
          });
      };
    

    validate = () => {
        const { subject, description   } = this.state;
    
        let subjectError;
        let messageError;
        if (!subject) {
            subjectError = true;
          this.errorHandler("subjectError", true);
        }
    
        if (!description) {
            messageError = true;
          this.errorHandler("messageError", true);
        }
    

        if (
          !subjectError &&
          !messageError 
        ) {
          // this.props.navigation.navigate("OtpScreen");
          console.log('Success')
          
        //   this.props.registration(this.state);
        } else {
          
        }
      };
  
  

    render() {
        
        return (
            <>
            <Header
            title="Contact"
            
            // headerRightClick={() => alert()}
            />
            <Container maxWidth='lg'>

            <div className='main-component'
            >
            
        <View style={{marginHorizontal: 10}}>
          
           <View style={{ flexDirection: 'column', flexWrap: 'wrap',marginTop:10, marginHorizontal: _width <= 479 ? 0 : 23}}>
           <ScrollView>
           <View style={{ width: '100%', marginTop: 10, alignSelf: 'center',}}>
                <Text style={{fontSize: 16, color: 'rgba(0,0,0,0.5)'}}>Subject</Text>
                {(this.state.subjectError) && (
                  <Text
                    style={{
                      color:  "#ff1a1a",
                      fontSize: 12,
                      marginVertical: 3,
                      textAlign: "right",
                    }}
                  >
                    {"Enter subject"}
                  </Text>
                )}
                  
                    <TextField
                        id="outlined-textarea"
                        variant="outlined"
                        style={{marginTop: 10}}
                        value={this.state.subject}
                        onChange={(e) => {
                            this.setState({
                                subject: e.target.value
                            })
                        }}
                        onBlur={() =>
                            this.state.subject
                              ? this.errorHandler("subjectError", false)
                              : this.errorHandler("subjectError", true)
                          }
                    />

              </View> 

              <View style={{ width: '100%', marginTop: 10, alignSelf: 'center',}}>
                <Text style={{fontSize: 16, color: 'rgba(0,0,0,0.5)'}}>Message</Text>
                {(this.state.messageError) && (
                  <Text
                    style={{
                      color:  "#ff1a1a",
                      fontSize: 12,
                      marginVertical: 3,
                      textAlign: "right",
                    }}
                  >
                    {"Enter message"}
                  </Text>
                )}
                <TextField
                id="outlined-multiline-static"
                multiline
                rows={15}
                variant="outlined"
                style={{marginTop: 10}}
                value={this.state.description}
                onChange={(e) => {
                    this.setState({
                        description: e.target.value
                    })
                }}
                onBlur={() =>
                    this.state.description
                      ? this.errorHandler("messageError", false)
                      : this.errorHandler("messageError", true)
                  }
                />

              </View> 
              <Button
                  onPress={() => this.validate()}
                  mode="contained"
                  style={styles.button}
                  uppercase={false}
                 
                >
                  <Text style={{ fontSize: 16, fontWeight: '600', color: '#fff' }}> submit</Text>
                </Button>
            </ScrollView> 
           </View>
        {/* ================ads screen ====================== */}
      
          {/* <AdsScreen screenId={'Library'} /> */}
      
            </View>
        {/* ================ads screen end ====================== */}
         </div>
         </Container>
         </>
        )
    }
}
const styles = StyleSheet.create({
    mainImageView:{
        flex:1 ,
        marginTop:10,
        height: 150,
        width:_width <= 479  ? Math.floor(_width/3 + 10) : Math.floor(width/2 - 30),
        marginHorizontal: 12,
        // marginBottom,
        elevation: 8,
        cursor: 'pointer',
        // backgroundColor: '#f00',
    //    alignItems: 'center',
       
},
    ImageView:{
        flex:1, 
        // flex: 1,
        borderRadius:10,
        width: _width <= 479  ? Math.floor(_width/3 + 30) : Math.floor(width/2 - 18),
        // height:400
    },
    container: {
        flex: 1,
        borderWidth:1,
    },
    
    main:{
        marginTop:10,
        height: 150,
        width:_width <= 780  ? Math.floor(_width - 40) : Math.floor(width/2 - 30),
        // borderRadius:10,
        borderWidth: 4,
        borderColor: "#fff",
        marginHorizontal: 10,
        position:'relative',
        overflow:'hidden'
    },

    inputBox: {
        width: width >780 ? '50%' : '90%',
        backgroundColor: 'transparent',
        // alignSelf: 'center'
        },
        button: {
        width: 200,
        borderRadius: 10,
        backgroundColor: '#00cc99',
        // borderRadius: 15,
        // borderWidth: 2,
        // borderColor: '#fff',
        height: 50, 
        marginTop: 10,
        justifyContent: 'center',
        alignItems:'center',
       
    
        },
        
})

const mapStateToProps = state => ({
    loading: state.allExams && state.allExams.loading,
    exams: state.allExams && state.allExams.exams && state.allExams.exams.exams,
    err: state.allExams && state.allExams.examPreferencesError && state.allExams.examPreferencesError,
  })
  

export default connect(mapStateToProps, {   })(ContactUS); 